// @flow
import * as React from 'react';
import './footer.scss'
type Props = {
  copyright: string
};
export const Footer = ({copyright}: Props) => {
  return (
    <footer className="footer-copyright">
      <div className="container">
        © {copyright} {new Date().getFullYear()}
      </div>
    </footer>
  );
};
